// Tiroir panier : prix de l'upsell qui suit la variante choisie dans sa liste. Écoute posée sur le document,
// car Dawn remplace le contenu du tiroir à chaque changement du panier.
document.addEventListener('change', (event) => {
  const select = event.target.closest?.('[data-dx-upsell-variant]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const item = select.closest('.dx-cart-upsell__item');
  if (!option || !item) return;
  const price = item.querySelector('[data-dx-price]');
  const compare = item.querySelector('[data-dx-compare]');
  if (price) price.textContent = option.dataset.price;
  if (compare) {
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
  }
});

// Titre « Cart (n) » : le tiroir est rechargé par Dawn à chaque changement, mais sur la page panier le titre est
// hors de la zone rechargée. On met à jour tous les compteurs depuis l'événement « panier mis à jour » de Dawn
// (réponse de /cart/change.js) ; un ajout depuis la fiche produit recharge déjà le tiroir.
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event?.cartData?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-dx-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  });
});

// AynWorld Care : la case du tiroir ajoute ou retire la garantie par le circuit panier de Dawn
// (/cart/add, /cart/change avec les sections du tiroir, puis renderContents et événement cartUpdate).
document.addEventListener('change', async (event) => {
  const input = event.target.closest?.('[data-aw-protection] input');
  if (!input) return;
  const box = input.closest('[data-aw-protection]');
  const drawer = document.querySelector('cart-drawer');
  const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
  const payload = input.checked
    ? { items: [{ id: Number(box.dataset.variantId), quantity: 1 }] }
    : { id: box.dataset.lineKey, quantity: 0 };
  box.classList.add('is-loading');
  input.disabled = true;
  try {
    const url = input.checked ? routes.cart_add_url : routes.cart_change_url;
    const response = await fetch(url, { ...fetchConfig(), body: JSON.stringify({ ...payload, sections, sections_url: window.location.pathname }) });
    const state = await response.json();
    if (state.status) throw new Error(state.description || state.message);
    if (drawer) drawer.renderContents({ ...state, id: Number(box.dataset.variantId) });
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aw-protection', cartData: state });
  } catch (error) {
    console.error(error);
    input.checked = !input.checked;
    input.disabled = false;
    box.classList.remove('is-loading');
  }
});
